<template>
  <div>
<div class="header bg-info pb-6">
  <span class="mask bg-gradient opacity-8"></span>
    <div class="container-fluid">
        <div class="header-body">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">Widgets</h6>
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb breadcrumb-links breadcrumb-dark">
                                <li class="breadcrumb-item">
                                <li class="breadcrumb-item"><a href="#/" class="active"><i class="fas fa-home"></i></a>
                                
                                </li>
                                <li class="breadcrumb-item" style="display: inline-block;"><a href="#/"
                                        class="active">Dashboards</a></li>
                                <li class="breadcrumb-item active" style="display: inline-block;"><span>Widgets</span>
                                </li>
                            </ol>
                        </nav>
                    </nav>
                </div>
                <div class="col-lg-6 col-5 text-right"><button type="button" class="btn base-button btn-neutral btn-sm">
                        <!---->New
                    </button><button type="button" class="btn base-button btn-neutral btn-sm">
                        <!---->Filters
                    </button></div>
            </div>
            <div class="row">
                <div class="col-xl-4 col-md-6" v-on:click="setNewcar()" >
                    <div class="card card-stats border-0" v-bind:class="{ 'bg-gradient-red': newcar }" show-footer-line="true">
                        <!---->
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h5 class="card-title text-uppercase text-muted mb-0">Angebot rechnen</h5><span
                                        class="h2 font-weight-bold mb-0">Neu-/Gebrauchtwagen</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape text-white rounded-circle shadow bg-gradient-blue"><i
                                            class="fas fa-car"></i></div>
                                </div>
                            </div>
                            <p class="mt-3 mb-0 text-sm"><span class="text-success mr-2"><i class="fa fa-arrow-up"></i>
                                    3.48%</span><span class="text-nowrap">Since last month</span></p>
                        </div>
                        <!---->
                        <!---->
                    </div>
                </div>

                <div class="col-xl-4 col-md-6" v-on:click="setInsurer()">
                    <div class="card card-stats border-0" v-bind:class="{ 'bg-gradient-red': insurer }" show-footer-line="true">
                        <!---->
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h5 class="card-title text-uppercase text-muted mb-0">Angebot rechnen</h5><span
                                        class="h2 font-weight-bold mb-0">Versichererwechsel</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape text-white rounded-circle shadow bg-gradient-blue"><i
                                            class="fas fa-university"></i></div>
                                </div>
                            </div>
                            <p class="mt-3 mb-0 text-sm"><span class="text-success mr-2"><i class="fa fa-arrow-up"></i>
                                    3.48%</span><span class="text-nowrap">Since last month</span></p>
                        </div>
                        <!---->
                        <!---->
                    </div>
                </div>
                <div class="col-xl-4 col-md-6" v-on:click="setTarrif()">
                    <div class="card card-stats border-0" v-bind:class="{ 'bg-gradient-red': tarrif }" show-footer-line="true">
                        <!---->
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h5 class="card-title text-uppercase text-muted mb-0">Angebot rechnen</h5><span
                                        class="h2 font-weight-bold mb-0">Tarifwechsel</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape text-white rounded-circle shadow bg-gradient-blue"><i
                                            class="fas fa-file-contract"></i></div>
                                </div>
                            </div>
                            <p class="mt-3 mb-0 text-sm"><span class="text-success mr-2"><i class="fa fa-arrow-up"></i>
                                    3.48%</span><span class="text-nowrap">Since last month</span></p>
                        </div>
                        <!---->
                        <!---->
                    </div>
                </div>
            </div>






            <!-- auswahl PKW / LKW -->
            <div class="row" v-if="kind_selected">
                <div v-on:click="setCar()" v-if="this.showCar" v-bind:class="[car ? 'col-xl-12 col-md-12' : 'col-xl-6 col-md-6']">
                    <div class="card card-stats border-0" v-bind:class="{ 'bg-gradient-red': car }" show-footer-line="true">
                        <!---->
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h5 class="card-title text-uppercase text-muted mb-0">Angebot rechnen</h5><span
                                        class="h2 font-weight-bold mb-0">PKW</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape text-white rounded-circle shadow bg-gradient-blue"><i
                                            class="fas fa-car"></i></div>
                                </div>
                            </div>
                            <p class="mt-3 mb-0 text-sm"><span class="text-success mr-2"><i class="fa fa-arrow-up"></i>
                                    3.48%</span><span class="text-nowrap">Since last month</span></p>
                        </div>
                        <!---->
                        <!---->
                    </div>
                </div>

                <div v-on:click="setVan()" v-if="this.showVan" v-bind:class="[van ? 'col-xl-12 col-md-12' : 'col-xl-6 col-md-6']">
                    <div class="card card-stats border-0" v-bind:class="{ 'bg-gradient-red': van }" show-footer-line="true">
                        <!---->
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h5 class="card-title text-uppercase text-muted mb-0">Angebot rechnen</h5><span
                                        class="h2 font-weight-bold mb-0">Nutzfahrzeug</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape text-white rounded-circle shadow bg-gradient-blue"><i
                                            class="fas fa-shuttle-van"></i></div>
                                </div>
                            </div>
                            <p class="mt-3 mb-0 text-sm"><span class="text-success mr-2"><i class="fa fa-arrow-up"></i>
                                    3.48%</span><span class="text-nowrap">Since last month</span></p>
                        </div>
                        <!---->
                        <!---->
                    </div>
                </div>
            </div>









            <!-- auswahl privat / firma -->
            <div class="row" v-if="vahicle_selected">
                <div class="col-xl-6 col-md-6" v-on:click="setPrivateCustomer()">
                    <div class="card card-stats border-0" v-bind:class="{ 'bg-gradient-red': private_customer }" show-footer-line="true">
                        <!---->
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h5 class="card-title text-uppercase text-muted mb-0">Angebot rechnen</h5><span
                                        class="h2 font-weight-bold mb-0">Privatkunde</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape text-white rounded-circle shadow bg-gradient-blue"><i
                                            class="fas fa-user"></i></div>
                                </div>
                            </div>
                            <p class="mt-3 mb-0 text-sm"><span class="text-success mr-2"><i class="fa fa-arrow-up"></i>
                                    3.48%</span><span class="text-nowrap">Since last month</span></p>
                        </div>
                        <!---->
                        <!---->
                    </div>
                </div>

                <div class="col-xl-6 col-md-6" v-on:click="setCompanyCustomer()">
                    <div class="card card-stats border-0" v-bind:class="{ 'bg-gradient-red': company_customer }" show-footer-line="true">
                        <!---->
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <h5 class="card-title text-uppercase text-muted mb-0">Angebot rechnen</h5><span
                                        class="h2 font-weight-bold mb-0">Firmenkunde</span>
                                </div>
                                <div class="col-auto">
                                    <div class="icon icon-shape text-white rounded-circle shadow bg-gradient-blue"><i
                                            class="fas fa-user-tie"></i></div>
                                </div>
                            </div>
                            <p class="mt-3 mb-0 text-sm"><span class="text-success mr-2"><i class="fa fa-arrow-up"></i>
                                    3.48%</span><span class="text-nowrap">Since last month</span></p>
                        </div>
                        <!---->
                        <!---->
                    </div>
                </div>
            </div>







        </div>
    </div>
</div>
<div class="container-fluid mt--6">
    <!-- b-row>
      <b-col lg="12">

        <h1>State </h1>

        Kunde: 
        <template v-if="private_customer">
          Privatkunde
        </template>
        <template v-if="company_customer">
          Firmenkunde
        </template>

        Fahrzeug:
        <template v-if="car">
          PKW
        </template>
        <template v-if="van">
          LWK
        </template>


        Auswahl:
        <template v-if="tarrif">
          Tarifwechsel
        </template>
        <template v-if="insurer">
          Versichererwechsel
        </template>
        <template v-if="newcar">
          Kunden-Neuzulassung
        </template>

      </b-col>
    </b-row -->
    
    <b-row v-if="false">
      <b-col lg="3">
        <!-- Pricing -->
        <card
          gradient=""
          header-classes="bg-transparent"
          footer-classes="bg-transparent"
          body-classes="px-lg-7"
          class="card-pricing border-0 text-center mb-4"
        >
          <!--Header-->
          <h4 slot="header" class="text-uppercase ls-1 py-3 mb-0">
            Privatkunde
            {{ offerstring() }}
          </h4>

          
          <!--Card Body-->
          <div class="display-2">$49</div>
          <span class="">per application</span>
          <ul class="list-unstyled my-4">
            <li>
              <div class="d-flex align-items-center">
                weiterer text hier
              </div>
            </li>
          </ul>

          <base-button type="primary" class="mb-3" @click="private_customer = true; startCalc()"
            ><i class="fas fa-calculator"></i> Jetzt anbieten</base-button
          >

        </card>
      </b-col>



      <b-col lg="3">
        <!-- Pricing -->
        <card
          gradient=""
          header-classes="bg-transparent"
          footer-classes="bg-transparent"
          body-classes="px-lg-7"
          class="card-pricing border-0 text-center mb-4"
        >
          <!--Header-->
          <h4 slot="header" class="text-uppercase ls-1 py-3 mb-0">
            Firmenkunde
             {{ offerstring() }}
          </h4>
          <!--Card Body-->
          <div class="display-2">$49</div>
          <span class="">per application</span>
          <ul class="list-unstyled my-4">
            <li>
              <div class="d-flex align-items-center">
                weiterer text hier
              </div>
            </li>
          </ul>

          <base-button type="primary" class="mb-3" @click="this.company_customer = true; startCalc()"
            ><i class="fas fa-calculator"></i> Jetzt anbieten</base-button
          >
       <!-- base-button type="primary" class="mb-3" @click="setNewcar(), setCar()"
            ><i class="fas fa-car"></i> PKW</base-button
          -->

           <!-- base-button type="primary" class="mb-3" @click="setNewcar(), setVan()"
            ><i class="fas fa-car"></i> PKW</base-button
          -->
        </card>
      </b-col>



      <b-col lg="3">
        <!-- Pricing -->
        <card
          gradient=""
          header-classes="bg-transparent"
          footer-classes="bg-transparent"
          body-classes="px-lg-7"
          class="card-pricing border-0 text-center mb-4"
        >
          <!--Header-->
          <h4 slot="header" class="text-uppercase ls-1 py-3 mb-0">
            Versichererwechsel
             {{ offerstring() }}
          </h4>
          <!--Card Body-->
          <div class="display-2">$49</div>
          <span class="">per application</span>
          <ul class="list-unstyled my-4">
            <li>
              <div class="d-flex align-items-center">
                weiterer text hier
              </div>
            </li>
          </ul>
          <base-button type="primary" class="mb-3" @click="this.private_customer = true; startCalc()"
            ><i class="fas fa-calculator"></i> Jetzt anbieten</base-button
          >
        </card>
      </b-col>

      <b-col lg="3">
        <!-- Pricing -->
        <card
          gradient=""
          header-classes="bg-transparent"
          footer-classes="bg-transparent"
          body-classes="px-lg-7"
          class="card-pricing border-0 text-center mb-4"
        >
          <!--Header-->
          <h4 slot="header" class="text-uppercase ls-1 py-3 mb-0">
            Tarifwechsel
             {{ offerstring() }}
          </h4>
          <!--Card Body-->
          <div class="display-2">$49</div>
          <span class="">per application</span>
          <ul class="list-unstyled my-4">
            <li>
              <div class="d-flex align-items-center">
                weiterer text hier
              </div>
            </li>
          </ul>
          <base-button type="primary" class="mb-3" @click="private_customer = true; startCalc()"
            ><i class="fas fa-calculator"></i> Jetzt anbieten</base-button
          >
        </card>
      </b-col>



    </b-row>



    <b-row>
      <b-col lg="6">
        <div class="card bg-dark text-white border-0"><img class="card-img" src="img/theme/img-1-1000x600.jpg" alt="Card image">
            <div class="card-img-overlay d-flex align-items-center">
                <div>
                    <h5 class="h2 card-title text-white mb-2">Meine Angebote</h5>
                    <p class="card-text"> This is a wider card with supporting text below as a natural lead-in to additional
                        content. This content is a little bit longer. </p>
                    <p class="card-text text-sm font-weight-bold"> Last updated 3 mins ago </p>
                </div>
            </div>
        </div>
      </b-col>
      <b-col lg="6">
        <div class="card bg-dark text-white border-0"><img class="card-img" src="img/theme/img-1-1000x600.jpg" alt="Card image">
            <div class="card-img-overlay d-flex align-items-center">
                <div>
                    <h5 class="h2 card-title text-white mb-2">EvB</h5>
                    <p class="card-text"> This is a wider card with supporting text below as a natural lead-in to additional
                        content. This content is a little bit longer. </p>
                    <p class="card-text text-sm font-weight-bold"> Last updated 3 mins ago </p>
                </div>
            </div>
        </div>
      </b-col>
    </b-row>


        <b-row>
      <b-col lg="12">
        <div class="card bg-dark text-white border-0"><img class="card-img" alt="Card image">
            <div class="card-img-overlay d-flex align-items-center">
                <div>
                    <h5 class="h2 card-title text-white mb-2">CALC {{ mayClculate }}</h5>
                </div>
            </div>
        </div>
      </b-col>
    </b-row>
   
   
   
   
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState, mapActions } from "vuex";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";

export default {
  components: {
    RouteBreadCrumb,
  },
  data() {
    return {
      loading: false,
      newcar: false,
      tarrif: false,
      insurer: false,
      company_customer: false,
      private_customer: false, 
      van: false,
      car: false,
      isset: false,

      customer_selected: false,
      vahicle_selected: false,
      kind_selected: false,

      showCar: true,
      showVan: true,

    };
  },
  methods: {
    toggleOptions(nm){
      console.log("toggle options for ");
    },

    startCalc(){
      console.log("Switching to new offer");

    //  this.offer.is_new_car = true;
    //  this.offer.is_car = true  ;
      console.log(this.offer.is_company);
      if(this.company_customer){
        this.offer.is_company = true;
        this.offer.car_usage = 'gewerblich';
        this.offer.car_usage_only_private = 0;
        this.offer.show_usage = false;
      }
      if(this.private_customer){
        this.offer.is_company = false;
        this.offer.car_usage = 'privat';
        this.offer.car_usage_only_private = 1;
        this.offer.show_usage = false;
      }
      console.log(this.offer.is_company);
     // this.offer.is_car = true;


      // set props for offer

//    showClaim(claimId) {
      //this.$router.push({ path: `/claims/${this.claim.token}` })
      //this.$router.push({ path: `/claims/${claimId}` })
      //this.$router.push({ path: `/claims/${claimId}`, query: { tab: 'Dokumente' } })


      this.offer.wizard = true;
      this.$router.push({
        name: 'Angebot anlegen',
      });
      
//},


    },

    offerstring(){
      if(this.car){
        return "PKW";
      }
      if(this.van){
        return "Nutzfahrzeug";
      }
    },

    setNewcar(){
      this.newcar = true;
      this.insurer = false;
      this.tarrif = false;
      this.kind_selected = true;

      this.offer.leveling_list = ["0","1"];
      this.offer.customer_has_free_sfr = '';
      this.offer.selected_free_sfr = false;

      this.showCar = true;
      this.showVan = true;

      // nulling sublevels
      this.van = false;
      this.car = false;
      this.vahicle_selected = false;
    },

    setInsurer(){
      this.newcar = false;
      this.insurer = true;
      this.tarrif = false;
      this.kind_selected = true;

      this.offer.leveling_list = ["2","4"];
      this.offer.customer_has_free_sfr = 1;
      this.offer.selected_free_sfr = true;

      //this.offer.v1 = true;

      this.showCar = true;
      this.showVan = true;

      // nulling sublevels
      this.van = false;
      this.car = false;
      this.vahicle_selected = false;





},
    
    setTarrif(){
      this.newcar = false;
      this.insurer = false;
      this.tarrif = true;
      this.kind_selected = true;

      this.offer.leveling_list = ["2","4"];
      this.offer.customer_has_free_sfr = 1;
      this.offer.selected_free_sfr = true;

      //this.offer.v1 = true;

      this.showCar = true;
      this.showVan = true;

      // nulling sublevels
      this.van = false;
      this.car = false;
      this.vahicle_selected = false;
    },

    setCompanyCustomer(){
      this.company_customer = true;
      this.private_customer = false;
      this.customer_selected = true;
    },

    setPrivateCustomer(){
      this.company_customer = false;
      this.private_customer = true;
      this.customer_selected = true;
    },

    setVan(){
      this.van = true;
      this.car = false;
      this.vahicle_selected = true;

      this.showCar = false;
      this.showVan = true;

      this.offer.is_car = false;
      this.offer.is_van = true;
    },

    setCar(){
      this.car = true;
      this.van = false;
      this.vahicle_selected = true;

      this.showCar = true;
      this.showVan = false;

      this.offer.is_car = true;
      this.offer.is_van = false;

    },

  },
  computed: {
    ...mapGetters({ currentAccount: "currentAccount" }),
    ...mapState({
      offer: (state) => state.offer,
      dealer: (state) => state.dealer,
    }),
    ...mapActions({
      resetOffer: (state) => state.resetOffer,
    }),


    mayClculate(){
      if(this.kind_selected && this.customer_selected && this.vahicle_selected){
        this.startCalc();
        return true;
        
      }
      else{
        return false;
      }
    }
  },
  mounted: function () {
      this.$store.dispatch("resetOffer", this.$route.params.token);
  },

};
</script>
<style>
.profile-header {
  background-image: url(/img/theme/profile-cover.jpg);
  background-size: cover;
  background-position: center top;
  min-height: 500px;
}
</style>
